import { useContext } from 'react';
import { AppContext } from '../context/AppContext';

export const useClearModal = () => {
  const { setModals } = useContext(AppContext);
  const clear = id => {
    setModals(ms => ms.filter(m => !m.id.match(id)));
  };
  return [clear];
};